import React from "react";
import { Box } from "@chakra-ui/layout";
import { useUserContext } from "../../context/UserContext";
import { usePermissions } from "../../hooks/usePermissions";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";

/**
 * Displays an error message when a user has no app menu permissions configured.
 */
export const RolesErrorBanner = () => {
  const { isSuperAdmin } = useUserContext();

  const [
    hasReadDetails,
    hasUserManagement,
    canSearchMembers,
    hasFinancialReportAccess,
    hasMembershipReportAccess,
    canInviteToCard,
  ] = usePermissions(
    "Member.ReadDetails",
    "User.Management",
    "Member.Search",
    "Reporting.Financial",
    "Reporting.Membership",
    "Member.InviteToCard"
  );

  const hasNoAppMenuPermissions =
    !hasReadDetails &&
    !hasUserManagement &&
    !canSearchMembers &&
    !hasFinancialReportAccess &&
    !hasMembershipReportAccess &&
    !canInviteToCard;

  if (!isSuperAdmin && hasNoAppMenuPermissions) {
    return (
      <Box position="relative" flex="1">
        <ErrorMessage width={"100%"}>
          Your account does not currently have any active roles assigned. Please
          log out and back in to refresh your access. If the issue persists,
          contact your administrator.
        </ErrorMessage>
      </Box>
    );
  }

  return null;
};
